import { useSnackbar } from "notistack";

type CopyParams = {
  copyText?: string;
  copyMessage?: string;
};

const useCopyToClipboard = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyClick = ({
    copyText = "Default text",
    copyMessage = "Text copied to clipboard!",
  }: CopyParams) => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        enqueueSnackbar(copyMessage, {
          variant: "success",
          autoHideDuration: 2000,
          style: {
            backgroundColor: "#F7F7F7",
            color: "#15182C",
          },
        });
      })
      .catch((err) => {
        enqueueSnackbar("Failed to copy text!", {
          variant: "error",
          autoHideDuration: 2000,
          style: {
            backgroundColor: "#FFE8E8",
            color: "#15182C",
          },
        });
        console.error("Failed to copy: ", err);
      });
  };

  return { handleCopyClick };
};

export default useCopyToClipboard;
